import React from "react";
import "./LegalPage.css";
import { useScrollToTopOnChange } from "../hooks/useScrollToTop";

const PAGE_CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "This page explains what information Nexite collects, how it is used, and the choices available to visitors and customers.",
    sections: [
      {
        heading: "Information We Collect",
        body: "We may collect contact details, project requirements, device/browser information, and communication history when you submit forms or contact us directly.",
      },
      {
        heading: "How We Use Information",
        body: "We use submitted information to respond to inquiries, deliver requested services, improve site performance, and maintain security and support operations.",
      },
      {
        heading: "Data Retention",
        body: "Information is retained only as long as necessary for business, legal, security, and support purposes, then removed or anonymized where appropriate.",
      },
    ],
  },
  terms: {
    title: "Terms of Use",
    intro: "These terms describe the acceptable use of the Nexite website and the general conditions under which information and services are provided.",
    sections: [
      {
        heading: "Website Use",
        body: "Visitors may browse and contact Nexite for legitimate business purposes. Misuse, unauthorized access attempts, or abusive behavior is prohibited.",
      },
      {
        heading: "Content Accuracy",
        body: "We aim to keep service descriptions, case studies, and contact information accurate, but content may change without prior notice.",
      },
      {
        heading: "External Links",
        body: "Links to third-party services such as maps or social platforms are provided for convenience. Nexite is not responsible for external site content or policies.",
      },
    ],
  },
  cookies: {
    title: "Cookie Notice",
    intro: "This page outlines how cookies and similar technologies may be used to support functionality, analytics, and performance on the Nexite website.",
    sections: [
      {
        heading: "Essential Cookies",
        body: "Some browser storage may be used to support navigation, basic functionality, and service reliability where required by the platform.",
      },
      {
        heading: "Performance and Analytics",
        body: "Usage and performance measurements may be collected to identify issues, improve load times, and optimize the user experience.",
      },
      {
        heading: "Managing Preferences",
        body: "Most browsers let you control or delete cookies. Disabling them may affect parts of the website experience or certain interactive features.",
      },
    ],
  },
};

function LegalPage({ type = "privacy" }) {
  const page = PAGE_CONTENT[type] || PAGE_CONTENT.privacy;

  useScrollToTopOnChange(type);

  return (
    <main className="legal-page">
      <header className="legal-hero">
        <div className="legal-container">
          <h1>{page.title}</h1>
          <p>{page.intro}</p>
        </div>
      </header>

      <section className="legal-section">
        <div className="legal-container">
          <div className="legal-card">
            {page.sections.map((section) => (
              <section key={section.heading} className="legal-block">
                <h2>{section.heading}</h2>
                <p>{section.body}</p>
              </section>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default LegalPage;